import { useState, useEffect, useRef } from 'react';
import { apiClient, getApiErrorMessage } from '../utils/api';
import CelebrationIcon from './icons/CelebrationIcon';

export default function PromotionPopup({ onClose, onClaimed }) {
    const [promotion, setPromotion] = useState(null);
    const [welcomeData, setWelcomeData] = useState(null);
    const [claiming, setClaiming] = useState(false);
    const [error, setError] = useState(null);

    const calledRef = useRef(false);

    useEffect(() => {
        if (calledRef.current) return;
        calledRef.current = true;

        apiClient.getEligiblePromotions()
            .then(res => {
                if (res?.data?.auto_redeemed) {
                    setWelcomeData({
                        title: res.message,
                        content: res.data.promote_content,
                        description: res.data.description,
                    });
                    onClaimed?.();
                    return;
                }
                const promo = res?.data?.promotion;
                if (promo?.id) {
                    setPromotion(promo);
                }
            })
            .catch(() => {});
    }, []);

    if (welcomeData) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                <div className="absolute inset-0 bg-black/40" onClick={() => onClose?.()} />
                <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4 text-center">
                    <div className="flex justify-center">
                        <CelebrationIcon />
                    </div>
                    {welcomeData.content ? (
                        <div
                            className="text-sm text-gray-700 space-y-2"
                            dangerouslySetInnerHTML={{ __html: welcomeData.content }}
                        />
                    ) : (
                        <>
                            <h3 className="text-lg font-semibold text-gray-800">
                                {welcomeData.title || 'Chào mừng bạn đến với Nebula!'}
                            </h3>
                            {welcomeData.description && (
                                <p className="text-sm text-gray-500">{welcomeData.description}</p>
                            )}
                        </>
                    )}
                    <button
                        onClick={() => onClose?.()}
                        className="w-full px-4 py-2.5 bg-brand-blue-500 hover:bg-brand-blue-600 text-white text-sm font-medium rounded-xl transition-colors"
                    >
                        Bắt đầu ngay
                    </button>
                </div>
            </div>
        );
    }

    if (!promotion) return null;

    const handleClaim = async () => {
        setClaiming(true);
        setError(null);
        try {
            const res = await apiClient.redeemPromotion(promotion.id);
            if (res?.success) {
                onClaimed?.();
                onClose?.();
            } else {
                setError(res?.message || 'Không thể nhận khuyến mãi');
            }
        } catch (err) {
            setError(getApiErrorMessage(err, 'Có lỗi xảy ra. Vui lòng thử lại.'));
        } finally {
            setClaiming(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40" onClick={() => onClose?.()} />
            <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-5">
                <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <span className="text-lg">🎁</span>
                        <span className="text-sm font-semibold text-gray-900">{promotion.name}</span>
                    </div>
                    <button onClick={() => onClose?.()} className="text-gray-400 hover:text-gray-600">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {promotion.description && (
                    <p className="text-sm text-gray-600 mb-3">{promotion.description}</p>
                )}

                {error && <p className="text-xs text-red-500 mb-2">{error}</p>}

                <div className="flex gap-2">
                    <button
                        onClick={handleClaim}
                        disabled={claiming}
                        className="flex-1 px-3 py-2 bg-blue-600 text-white text-sm font-medium rounded-xl hover:bg-blue-700 disabled:opacity-50 transition-colors"
                    >
                        {claiming ? 'Đang xử lý...' : 'Nhận ngay'}
                    </button>
                    <button
                        onClick={() => onClose?.()}
                        className="px-3 py-2 text-gray-600 text-sm rounded-xl hover:bg-gray-100 transition-colors"
                    >
                        Để sau
                    </button>
                </div>
            </div>
        </div>
    );
}
